<template>
  <div
    v-if="!isLoading2 && ready"
    class="section"
  >
    <div class="columns is-centered">
      <div class="column is-11">
        <div class="columns">
          <div class="column has-text-centered">
            <h2 class="title is-2">
              Reports Dashboard
            </h2>
            <div class="subtitle is-2">
              Stats by Year
            </div>
          </div>
        </div>
        <div class="columns stats has-text-centered is-vcentered">
          <div class="column is-3">
            <div class="columns has-text-centered is-vcentered is-centered">
              <div class="column is-1 is-paddingless">
                <a
                  v-show="hasPrevYear"
                  href="#"
                  aria-label="Decrease Year"
                  @click="updateCurrentYear(currentYear - 1)"
                >
                  <span
                    class="icon"
                    aria-hidden="true"
                  >
                    <i class="fad fa-arrow-circle-left" />
                  </span>
                </a>
              </div>
              <div class="column is-4 is-paddingless">
                <div class="is-size-4 is-inline-block">
                  &nbsp; {{ currentYear }} &nbsp;
                </div>
              </div>
              <div class="column is-1 is-paddingless">
                <a
                  v-show="hasNextYear"
                  href="#"
                  aria-label="Increase Year"
                  @click="updateCurrentYear(currentYear + 1)"
                >
                  <span
                    class="icon"
                    aria-hidden="true"
                  >
                    <i class="fad fa-arrow-circle-right" />
                  </span>
                </a>
              </div>
            </div>
            <h3 class="is-size-3">
              {{ stats.totalCount.toLocaleString() }} filings<br>
            </h3>
            <h4 class="is-size-4">
              {{ stats.totalFilers.toLocaleString() }} filers
            </h4>
          </div>
          <div class="column is-3">
            <div class="columns stat-group">
              <div class="column">
                <div class="stat">
                  <h4 class="is-size-5">
                    State Filings
                  </h4>
                  <div class="is-size-5">
                    {{ stats.stateFilers.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.stateFilersCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Not completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.stateFilersNotCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Online
                  </h4>
                  <div class="is-size-5">
                    {{ stats.stateFilersOnline.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Paper Filing
                  </h4>
                  <div class="is-size-5">
                    {{ stats.stateFilersPaper.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="columns stat-group">
              <div class="column">
                <div class="stat">
                  <h4 class="is-size-5">
                    City Filings
                  </h4>
                  <div class="is-size-5">
                    {{ stats.cityFilers.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.cityFilersCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Not completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.cityFilersNotCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Online
                  </h4>
                  <div class="is-size-5">
                    {{ stats.cityFilersOnline.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Paper Filing
                  </h4>
                  <div class="is-size-5">
                    {{ stats.cityFilersPaper.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="columns stat-group">
              <div class="column">
                <div class="stat">
                  <h4 class="is-size-5">
                    Mayor Filings
                  </h4>
                  <div class="is-size-5">
                    {{ stats.mayorFilers }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.mayorFilersCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Not completed
                  </h4>
                  <div class="is-size-5">
                    {{ stats.mayorFilersNotCompleted.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns stat-group">
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Online
                  </h4>
                  <div class="is-size-5">
                    {{ stats.mayorFilersOnline.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div class="column is-half">
                <div class="stat">
                  <h4 class="is-size-7">
                    Paper Filing
                  </h4>
                  <div class="is-size-5">
                    {{ stats.mayorFilersPaper.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column has-text-centered">
            <h2 class="title is-2">
              Generate Reports
            </h2>
            <div class="subtitle is-2">
              Start by selecting a type of report below
            </div>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-5">
            <dropdown
              v-model="report"
              :options="reports"
              value-key="key"
              text-key="label"
              default-option="Select Report"
              placeholder="Select Report"
            />
          </div>
        </div>
        <div
          v-if="currentReport.length > 0"
          class="columns"
        >
          <div class="column">
            <component :is="currentReport" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dropdown } from '@phila/phila-ui';

export default {
  name: 'Reports',
  components: {
    Dropdown,
    'report-filers-status': () => import('@/components/ReportFilersStatus'),
    'report-filings-by-month': () => import('@/components/ReportFilingsByMonth'),
  },
  data() {
    return {
      ready: false,
      agencies: [],
      currentYear: null,
      report: {},
      reports: [
        {
          label: 'Filers Status by Year',
          key: 'report-filers-status',
        },
        {
          label: 'Completed Filings by Month',
          key: 'report-filings-by-month',
        },
      ],
    };
  },
  computed: {
    stats () {
      return this.$store.state.reports.stats;
    },
    years () {
      let years = [];
      let yearsObj = this.$store.getters[ 'admin/activeControlValues' ]('currentyear');
      if (yearsObj) {
        years = yearsObj.map(year => parseInt(year.description)).sort();
      }
      return years;
    },
    hasNextYear () {
      if (this.years.indexOf(this.currentYear + 1) !== -1){
        return true;
      }
      return false;
    },
    hasPrevYear () {
      if (this.years.indexOf(this.currentYear - 1) !== -1){
        return true;
      }
      return false;
    },
    currentReport () {
      if (this.report !== '') {
        return this.report;
      }
      return '';
    },
  },
  watch: {
    currentYear () {
      this.$store.dispatch('reports/fetchStats', this.currentYear);
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$store.commit('loading', false);
    this.ready = true;
  },
  methods: {
    async initialAssign () {
      if (!this.year) {
        this.currentYear = this.years[this.years.length - 1];
      }
    },
    async initialFetch () {
      let promises = [];
      await promises.push(this.$store.dispatch('admin/getControlValue', 'currentyear'));
      promises.push(this.$store.dispatch('reports/fetchStats', this.years[this.years.length - 1]));
      return Promise.all(promises);
    },
    getUserProfile () {
      return this.cloneObj(this.$store.state.user.profile);
    },
    updateCurrentYear (num) {
      if (this.years.indexOf(num) !== -1){
        this.currentYear = num;
      }
    },
    getAgencies () {
      if (this.userProfile.sysAdmin === 'Y') {
        return this.cloneObj(this.$store.getters[ 'admin/activeControlValues' ]('agency'));
      }
      let agencies = this.cloneObj(this.$store.getters[ 'admin/activeControlValues' ]('agency'));
      let allowedAgencies = agencies.filter(agency => {
        if (this.deptAccess.includes(agency.id)){
          return true;
        }
        return false;
      });
      return allowedAgencies;
    },
    getUserDeptsAccess () {
      return this.$store.state.user.deptAccess;
    },
  },
};
</script>
<style lang="scss">
  .v-dropdown-caller {
    width: 100%;
    .sm-caller-container {
      width: 100%;
      button.sm-default-btn {
        width: 100%;
        max-width: 100%;
        text-align: left;
        border-radius: 0;
        box-shadow: none;
        height: 40px;
        padding: 0 0 0 10px;
        vertical-align: middle;
        > div {
          max-width: 90%;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 40px;
          &:before {
            content: " ";
            background: white;
            width: 30px;
            height: 100%;
            display: block;
            z-index: 9;
            top: 0;
            right: 0;
            position: absolute;
          }
          &:after {
            content: "";
            right: 1.125em;
            z-index: 10;
            border: 3px solid transparent;
            border-color: #0f4d8f;
            border-radius: 2px;
            border-right: 0;
            border-top: 0;
            display: block;
            height: 0.625em;
            margin-top: -0.4375em;
            pointer-events: none;
            position: absolute;
            top: 50%;
            transform-origin: center;
            width: 0.625em;
            transform: rotate(-45deg);
          }
        }
      }
    }
  }
  .stats {
    .stat {
      height: 100%;
    }
    .stat-group {
      font-weight: 600;
      .column {
        padding: .2rem;
        &:first-of-type {
          border-right: 1px solid $white;
        }
      }
      .stat {
        padding: 0.2rem;
      }
    }
    > .column {
      &:nth-child(2) {
        .stat {
          background-color: $electric-blue;
        }
      }
      &:nth-child(3) {
        .stat {
          background-color: $ben-franklin-blue-light;
        }
      }
      &:nth-child(4) {
        .stat {
          background-color: $ghost-grey;
        }
      }
    }
  }
</style>
